export type MGOrientation = "square" | "horizontal" | "vertical";

export const orientations = new Map<MGOrientation, string>([
  ["square", "Square"],
  ["horizontal", "Horizontal / Landscape"],
  ["vertical", "Vertical / Portrait"],
]);
